import React, { useState } from 'react'
import Timeline from './Timeline'
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    ButtonGroup,
} from "@material-tailwind/react";

function Description() {
    const [relatedMembers, setrelatedMembers] = useState([1,2,3,4,5,6,7,8,9])
    const [isSeeMore, setSeeMore] = useState(false)
    const [isActionOpen, setActionOpen] = useState(false)
    const [isTimelineOpen, setisTimelineOpen] = useState(false)
    const [isSubOpen, setSubOpen] = useState(false)
    const [scrnshot,setscrnshot]=useState()
    const [open, setOpen] = useState(false);
    const [file, setFile] = useState();

    // const handleSeeMore = () => {

    //     setSeeMore(!isSeeMore); // Toggle the value of isSeeMore
    //     setrelatedMembers(isSeeMore ? [1, 2, 3] : [1, 2, 3, 4, 5]);

    // }

    const handleTimelineOpen = () => {
        setisTimelineOpen(!isTimelineOpen)
        setSubOpen(false)
    }

    const handleSubtitleOpen = () => {
        setSubOpen(!isSubOpen)
        setisTimelineOpen(false)
    }

    const handleOpen = () => setOpen(!open);

    const handleUploadScreenshot = (e) => {
        // Your logic for handling file upload
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        // Assuming you have an image element with an ID of 'screenshotImage'
        const imgElement = document.getElementById('screenshotImage');

        // Update the image source when a file is selected
        if (imgElement && selectedFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                imgElement.src = e.target.result;
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleCloseModal=()=>{
        setOpen(!open)
        setFile(null)
    }

    return (
        <div className='flex flex-col w-full h-full'>
            <div className='flex justify-center' style={{ height: '100%', width: '100%' }}>
                <div className='lg:w-9/12 w-full flex lg:flex-row flex-col mt-12'>
                    {/* Description */}
                    <div className='flex flex-col lg:w-9/12 w-full '>
                        <div className='lg:text-left text-center'><h2 className='text-xl font-semibold'>Budget Presentation</h2></div>
                        <div className='lg:w-10/12 w-11/12 lg:text-left text-center '><p className='mt-6 lg:ms-0 ms-8'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus quia, esse nulla id quibusdam corrupti saepe atque libero! Accusantium beatae obcaecati perspiciatis ratione ex alias excepturi unde at aspernatur accusamus.</p></div>
                        <div className='mt-6 flex flex-row lg:w-5/12 w-10/12 justify-between lg:text-left text-left lg:ms-0 ms-8' style={{ color: '#606060' }}>
                            <div className='flex flex-col ' >
                                <p  >KLA</p>
                                <p className='mt-5'>Session</p>
                                <p className='mt-5'>Event</p>
                                <p className='mt-5'>Sitting Date</p>
                                <p className='mt-5'>Duration</p>
                                {/* <p className='mt-5'>Views Count</p> */}
                            </div>

                            <div className='flex flex-col'>
                                <p>15 th</p>
                                <p className='mt-5'>5 th</p>
                                <p className='mt-5'>Budget Speech</p>
                                <p className='mt-5'>23-02-2024</p>
                                <p className='mt-5'>45 Minutes</p>
                                {/* <p className='mt-5'>1.45k</p> */}

                            </div>
                        </div>




                    </div>

                    {/* Related members */}
                    <div className='flex lg:w-3/12 w-11/12 lg:mt-0 mt-6 '>
                        <div className='flex flex-col w-full'>
                            <div className='flex justify-center mb-2 lg:ms-0 ms-8 '><h5>Members</h5></div>
                            
                            <div className='flex justify-center mt-2 mb-2 lg:ms-0 ms-8 border-b'><div className='w-5 h-1 bg-primary rounded-xl mb-2'></div></div>

                           <div className='w-full h-96 overflow-hidden overflow-y-scroll hide-scroll-bar border-b'>
                             <div className='flex justify-end flex-col mt-4 lg:ms-0 ms-8 ' >
                                 {relatedMembers?.map((members, index) => (
                                     <div key={index} className='w-full h-24 flex justify-around items-center mb-3 border hover:shadow-xl' style={{ borderRadius: '14px', border: '1px solid #001F33' }}>
                                         <div><img src="https://ministersandgovernors.com/wp-content/uploads/2020/03/Pinarayi-Vijayan.jpg" alt="Profie" className='w-20 h-20 rounded-full' /></div>
                            
                                         <div className='flex flex-col'>
                                             <div><h4 className=''>Pinarayi Vijayan</h4></div>
                                             <div><p style={{ color: '#878787' }}>Chief Minister</p></div>
                                         </div>
                                     </div>
                                 ))}
                            
                             </div>
                            
                           </div>
                            {/* <div className='flex justify-end me-2 text-blue-800 cursor-pointer mt-4' onClick={handleSeeMore}>{!isSeeMore ? 'See More' : 'See Less'}</div> */}
                                {/* <div className='flex justify-center mt-2 lg:ms-0 ms-8'><div className='w-4 h-1 bg-blue-gray-900 rounded-xl '></div></div> */}


                        </div>
                    </div>


                </div>


            </div>

            {/* Action button */}
            <div className='w-full h-full flex justify-center'>
                <div className='lg:w-9/12 w-full h-full flex flex-row '>
                    <div className='lg:w-9/12 w-11/12 flex fle-row lg:justify-start justify-center lg:mt-0 mt-8'>
                        {/* Actions */}
                        <div className='flex flex-row lg:w-5/12 w-8/12 lg:ms-0 ms-8 '>
                            <button onClick={e => { isActionOpen ? setActionOpen(false) : setActionOpen(true) }} className='w-full text-white h-16 rounded-full text-xl ' style={{ backgroundColor: '#001F33' }}>Actions
                                <i className={isActionOpen ? 'fa-solid fa-caret-up ms-3 fa-xl' : 'fa-solid fa-caret-down ms-3 fa-xl'}></i>
                            </button>
                        </div>
                        {/* views */}
                        <div className='ms-10 flex flex-row w-4/12 '>
                            <button className='lg:w-6/12 w-full text-white h-16 rounded-full text-lg font-semibold' style={{ color: '#001F33', border: '1px solid #001F33' }}>  <i className="fa-solid fa-eye me-3"></i>1.44 K
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            {/* Four Actions on clicking action button */}
            {isActionOpen && <div className='flex flex-row  w-full h-full justify-center '>
                <div className='lg:w-9/12 w-11/12  flex lg:justify-between justify-center lg:mt-16 mt-10 lg:ms-0 ms-2'>

                    {/* Timeline */}
                    <div className='flex flex-row h-12' style={{ width: '24%' }} >
                        <button onClick={handleTimelineOpen} className={isTimelineOpen ? 'bg-success rounded-full h-full w-full hover:bg-primary hover:text-white' : 'rounded-full h-full w-full hover:bg-primary hover:text-white'} style={{ border: '1px solid #001F33' }}>
                            Timeline<i className={isTimelineOpen ? 'fa-solid fa-caret-up lg:ms-3 ms-1 fa-lg' : 'fa-solid fa-caret-down lg:ms-3 ms-1 fa-lg'}></i>
                        </button>
                    </div>

                    <div className='flex flex-row h-12' style={{ width: '24%' }} >
                        <button className='rounded-full h-full w-full hover:bg-primary hover:text-white' style={{ border: '1px solid #001F33' }}>
                            Download<i class="fa-solid fa-cloud-arrow-down lg:ms-3 ms-1 fa-lg hidden lg:inline-block"></i>
                        </button>
                    </div>

                    <div className='flex flex-row h-12' style={{ width: '24%' }} >
                        <button onClick={handleSubtitleOpen} className={isSubOpen ? 'backdrop-blur-md bg-success rounded-full h-full w-full hover:bg-primary hover:text-white' : 'rounded-full h-full w-full hover:bg-primary hover:text-white'} style={{ border: '1px solid #001F33' }}>
                            Subtitles<i className={isSubOpen ? 'fa-solid fa-caret-up fa-lg lg:ms-3 ms-1 ' : 'fa-solid fa-caret-down fa-lg lg:ms-3 ms-1 '}></i>
                        </button>
                    </div>

                    <div className='flex flex-row h-12' style={{ width: '24%' }} >
                        <button onClick={handleOpen} className='rounded-full h-full w-full hover:text-white text-danger hover:bg-danger' style={{ border: '1px solid #DC3545' }}>
                            Report issue
                            <i className="fa-solid fa-circle-exclamation ms-3 fa-lg hidden lg:inline-block "></i>
                        </button>
                    </div>

                </div>
            </div>}


            {/* Timelineopen */}
            {isTimelineOpen && <div className='flex flex-row  w-full h-full justify-center'>
                {/* <div className='lg:w-9/12 w-full  flex lg:justify-between justify-around lg:mt-16 mt-10 bg-primary h-60'>
                    hel
                </div> */}
                <Timeline />
            </div>}



            {/* Subtitleeopen */}
            {isSubOpen && <div className='flex flex-row  w-full h-full justify-center '>
                <div className='lg:w-9/12 w-full  flex lg:justify-between justify-around lg:mt-16 mt-10 mb-5'>

                    {/* Timeline */}
                    <div className='flex flex-row h-12 ' style={{ width: '24%', visibility: 'hidden' }} >
                        <button className='rounded-full h-full w-full hover:bg-primary hover:text-white' style={{ border: '1px solid #001F33' }}>
                            Timeline<i className={isTimelineOpen ? 'fa-solid fa-caret-up lg:ms-3 ms-1 fa-lg' : 'fa-solid fa-caret-down lg:ms-3 ms-1 fa-lg'}></i>
                        </button>
                    </div>

                    <div className='flex flex-row h-12' style={{ width: '24%', visibility: 'hidden' }} >
                        <button className='rounded-full h-full w-full hover:bg-primary hover:text-white' style={{ border: '1px solid #001F33' }}>
                            Download<i class="fa-solid fa-cloud-arrow-down lg:ms-3 ms-1 fa-lg"></i>
                        </button>
                    </div>

                    {/* subtitle shown box */}

                    <div className='flex flex-row h-40 justify-evenly  lg:w-1/4 w-2/4 rounded-lg bg-success' style={{ border: '1px solid #001F33' }}>
                        <div className='flex flex-col '>
                            <div className='flex justify-evenly mt-10 '><h2 className='text-xl '>Malayalam<i class="fa-solid fa-cloud-arrow-down lg:ms-3 ms-1 fa-lg"></i></h2></div>
                            <div className='flex justify-evenly mt-10'><h2 className='text-xl'>English<i class="fa-solid fa-cloud-arrow-down lg:ms-3 ms-1 fa-lg"></i></h2></div>
                        </div>

                    </div>

                    <div className='flex flex-row h-12' style={{ width: '24%', visibility: 'hidden' }} >
                        <button className='rounded-full h-full w-full hover:text-white text-danger hover:bg-danger' style={{ border: '1px solid #DC3545' }}>
                            Report issue
                            <i className="fa-solid fa-circle-exclamation ms-3 fa-lg hidden lg:inline-block "></i>
                        </button>
                    </div>
                </div>
            </div>
            }


            <div className='w-full h-full justify-center flex'>
                <div className='lg:w-9/12 w-10/12 h-1 bg-primary flex justify-center mb-5 mt-24'></div>
            </div>


            {/* Issue Raise Modal */}

            <Dialog open={open} handler={handleOpen} className="bg-white">
            <DialogHeader>Report Issue</DialogHeader>
            <DialogBody>
                Video id: 846476889o278978o7r98
                <div className='mt-5'>
                    <textarea name="issuebox" placeholder='Enter Issues Here' id="issuebox" className='w-full h-32 max-h-72 min-h-20  p-3'  style={{border:'1px solid #001F33'}}></textarea>
                </div>
                <div className='flex flex-row justify-content-center mt-3 w-12/12 h-6/12' style={{border:'1px solid #001F33'}}>
                    <label htmlFor="profile" className='text-center'>
                        <input onChange={handleUploadScreenshot} id='profile' type="file" style={{ display: 'none' }}  />
                        <div className='flex flex-row items-center w-full h-full'>
                          <div className=''>
                              <img id='screenshotImage'  src={file ? URL.createObjectURL(file) : 'https://media.istockphoto.com/id/1021471354/vector/image-upload-icon.jpg?s=612x612&w=0&k=20&c=TBKGW7vES1EtPcaxIvCAKxXL0W9EGd5FPBWHhtC2kFg='} className='w-52 h-40 rounded-circle ' alt="Update Image" />
                          </div>
                            <div>
                                {!file&&<h2 className='ms-5 font-bold text-xl'>Upload Screenshot</h2>}
                            </div>
                        </div>
                    </label>
                </div>
            </DialogBody>
            <DialogFooter>
                <Button
                    onClick={handleCloseModal}
                    className="mr-1"
                    variant="outlined"
                    color="red"
                    
                >
                    <span>Cancel</span>
                </Button>
                <Button variant="gradient" color="green" onClick={handleOpen}>
                    <span>Confirm</span>
                </Button>
            </DialogFooter>
        </Dialog>


        </div >
    )
}

export default Description